module.exports = __webpack_public_path__ + "res/Roboto-BlackItalic-webfont.ttf?9ce7c0ef5828aa5927c58817485eb180";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-BlackItalic-webfont.ttf
// module id = 94
// module chunks = 0